import {Component, OnInit} from '@angular/core';
import {ModalInterface} from "../../modal.interface";
import {Observable, of, Subject} from "rxjs";
import {UntypedFormGroup} from "@angular/forms";
import {ModalState} from "../../modal-state.enum";
import {ProjectRestService} from "../../../../api/services/project.rest.service";
import {ModalStateEvent} from "../../modal-state-event";
import {UsersQueryDataProviderService} from "../../../services/users-query.data-provider.service";
import {RxFormBuilder, RxwebValidators} from "@rxweb/reactive-form-validators";
import {AbstractComponent} from "../../../../core/components/abstract-component";
import {ModalComponent} from "../../modal.component";
import {MarketplaceAdvertisementApiModel} from "../../../../api/models/marketplace-advertisement.api.model";

@Component({
  selector: 'app-change-main-owner',
  templateUrl: './change-main-owner.component.html',
  styleUrls: ['./change-main-owner.component.scss']
})
export class ChangeMainOwnerComponent extends AbstractComponent implements OnInit, ModalInterface {

  public data: any;
  public parent?: ModalComponent;
  public subject: Subject<ModalStateEvent>;
  public state: Observable<ModalStateEvent>;
  public form: UntypedFormGroup
  public offer: MarketplaceAdvertisementApiModel

  constructor(
    private readonly fb: RxFormBuilder,
    private readonly projectRS: ProjectRestService,
    public readonly usersQueryDPS: UsersQueryDataProviderService
  ) {
    super();
  }

  ngOnInit(): void {
    this.offer = this.data['offer'];
    this.createForm()
    this.subscriptions.push(this.usersQueryDPS.fetchResourcesFromQuerySubject(query =>
      this.offer?.project?.slug ? this.projectRS.findOwnerCandidates(this.offer.project.slug, query) : of([])
    ).subscribe());
    this.subscribeParentModalState();
  }


   createForm(): void {
    this.form = this.fb.group({
      email: ['', [
        RxwebValidators.minLength({value: 2}),
        RxwebValidators.maxLength({value: 255}),
      ]],
      from: [null, [RxwebValidators.required(), RxwebValidators.date()]],
      pin: [null, [RxwebValidators.required()]]
    });
  }

  private emitValidState(): void {
      this.subject.next(new ModalStateEvent(ModalState.VALID));
  }

  private emitSuccessState(): void {
    this.subject.next(new ModalStateEvent(ModalState.SUCCESS));
  }

  private emitPendingState(): void {
    this.subject.next(new ModalStateEvent(ModalState.PENDING));
  }

  private subscribeParentModalState(): void {
    this.subscriptions.push(this.state.subscribe(modalState => {
      if (modalState.status === ModalState.PENDING) {
        this.submit()
      }
    }));
  }
  private submit(): void {
    console.log(this.form);
    if(this.form.valid) {
      const value = this.form.value;
      const ownerInput = typeof value.email === 'string' && /^\/api\/users\/[^/]+$/.test(value.email)
        ? {...value, email: null, user: value.email}
        : value;
      this.subscriptions.push(this.projectRS.changeOwner(this.offer.project, ownerInput).subscribe(() => {
        this.emitSuccessState();
      }));
    }
  }

  getAutocompleteOptionValue(item: any): any {
    return item.user?.['@id'] || item.user || item.email;
  }

  getAutocompleteOptionLabel(item: any): any {
    return item.alias;
  }

  public searchUsers(queryEvt): void {
    const query = String(queryEvt.query || '').trim();
    this.usersQueryDPS.resultSubject$.next(query);
  }
}
